import React from 'react';
import { useHistory } from 'react-router-dom';
import logo from '../../assets/images/icon-light.png';
import styles from './styles.module.css';


export default function NotFound(){
    const history = useHistory();

    return(
        <div>
            <span className={styles.span} >
                Poxa, não encontramos essa página
            </span>

            <span className={styles.error} >
                404
            </span>

            <br></br>

            <div className={styles.container} >
                <button  className={styles.btn} onClick={() => history.push('/dashboard')} > <div>&#8592;</div>  <div>Voltar</div></button>
            </div>
            
            <div className={styles.icon} >
                <img height={70} src={logo} id="icon" alt="image icon" />
            </div>
            
        </div>
    )
}
